import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

type UhxVariantIds = Record<
  ShopifyStore,
  { Year1: string; Year2: string; Month3: string }
>;

export const uhxVariantIds: UhxVariantIds =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? {
        [ShopifyStore.IN]: {
          Year1: 'gid://shopify/ProductVariant/42178684354630',
          Year2: 'gid://shopify/ProductVariant/42189944815686',
          Month3: 'gid://shopify/ProductVariant/44331688067142',
        },
        [ShopifyStore.AE]: {
          Year1: 'gid://shopify/ProductVariant/51627504140659',
          Year2: 'gid://shopify/ProductVariant/51628981518707',
          Month3: 'gid://shopify/ProductVariant/62359756374387',
        },
        [ShopifyStore.ROW]: {
          Year1: 'gid://shopify/ProductVariant/42199560552508',
          Year2: 'gid://shopify/ProductVariant/42216495448124',
          Month3: 'gid://shopify/ProductVariant/40908419989564',
        },
        [ShopifyStore.US]: {
          Year1: 'gid://shopify/ProductVariant/41322443374688',
          Year2: 'gid://shopify/ProductVariant/41333972074592',
          Month3: 'gid://shopify/ProductVariant/40200379727968',
        },
        [ShopifyStore.GB]: {
          Year1: 'gid://shopify/ProductVariant/50437365563710',
          Year2: 'gid://shopify/ProductVariant/50461136355646',
          Month3: 'gid://shopify/ProductVariant/49202073993534',
        },
        [ShopifyStore.EU]: {
          Year1: 'gid://shopify/ProductVariant/50437365563710',
          Year2: 'gid://shopify/ProductVariant/50461136355646',
          Month3: 'gid://shopify/ProductVariant/49202073993534',
        },
        [ShopifyStore.AU]: {
          Year1: 'gid://shopify/ProductVariant/50437365563710',
          Year2: 'gid://shopify/ProductVariant/50461136355646',
          Month3: 'gid://shopify/ProductVariant/49202073993534',
        },
        [ShopifyStore.CA]: {
          Year1: 'gid://shopify/ProductVariant/41322443374688',
          Year2: 'gid://shopify/ProductVariant/41333972074592',
          Month3: 'gid://shopify/ProductVariant/40200379727968',
        },
        [ShopifyStore.SA]: {
          Year1: 'gid://shopify/ProductVariant/50437365563710',
          Year2: 'gid://shopify/ProductVariant/50461136355646',
          Month3: 'gid://shopify/ProductVariant/49202073993534',
        },
        [ShopifyStore.MX]: {
          Year1: 'gid://shopify/ProductVariant/50437365563710',
          Year2: 'gid://shopify/ProductVariant/50461136355646',
          Month3: 'gid://shopify/ProductVariant/49202073993534',
        },
        [ShopifyStore.ZA]: {
          Year1: 'gid://shopify/ProductVariant/50437365563710',
          Year2: 'gid://shopify/ProductVariant/50461136355646',
          Month3: 'gid://shopify/ProductVariant/49202073993534',
        },
        [ShopifyStore.JP]: {
          Year1: 'gid://shopify/ProductVariant/50437365563710',
          Year2: 'gid://shopify/ProductVariant/50461136355646',
          Month3: 'gid://shopify/ProductVariant/49202073993534',
        },
      }
    : {
        [ShopifyStore.IN]: {
          Year1: 'gid://shopify/ProductVariant/40858437845065',
          Year2: 'gid://shopify/ProductVariant/40858437845065',
          Month3: 'gid://shopify/ProductVariant/44331688067142',
        },
        [ShopifyStore.AE]: {
          Year1: 'gid://shopify/ProductVariant/40858437845065',
          Year2: 'gid://shopify/ProductVariant/40858437845065',
          Month3: 'gid://shopify/ProductVariant/62359756374387',
        },
        [ShopifyStore.ROW]: {
          Year1: 'gid://shopify/ProductVariant/40858437845065',
          Year2: 'gid://shopify/ProductVariant/40858437845065',
          Month3: 'gid://shopify/ProductVariant/40908419989564',
        },
        [ShopifyStore.US]: {
          Year1: 'gid://shopify/ProductVariant/40858437845065',
          Year2: 'gid://shopify/ProductVariant/40858437845065',
          Month3: 'gid://shopify/ProductVariant/40200379727968',
        },
        [ShopifyStore.GB]: {
          Year1: 'gid://shopify/ProductVariant/40858437845065',
          Year2: 'gid://shopify/ProductVariant/40858437845065',
          Month3: 'gid://shopify/ProductVariant/49202073993534',
        },
        [ShopifyStore.EU]: {
          Year1: 'gid://shopify/ProductVariant/40858437845065',
          Year2: 'gid://shopify/ProductVariant/40858437845065',
          Month3: 'gid://shopify/ProductVariant/49202073993534',
        },
        [ShopifyStore.AU]: {
          Year1: 'gid://shopify/ProductVariant/50437365563710',
          Year2: 'gid://shopify/ProductVariant/50461136355646',
          Month3: 'gid://shopify/ProductVariant/49202073993534',
        },
        [ShopifyStore.CA]: {
          Year1: 'gid://shopify/ProductVariant/41322443374688',
          Year2: 'gid://shopify/ProductVariant/41333972074592',
          Month3: 'gid://shopify/ProductVariant/40200379727968',
        },
        [ShopifyStore.SA]: {
          Year1: 'gid://shopify/ProductVariant/50437365563710',
          Year2: 'gid://shopify/ProductVariant/50461136355646',
          Month3: 'gid://shopify/ProductVariant/49202073993534',
        },
        [ShopifyStore.MX]: {
          Year1: 'gid://shopify/ProductVariant/50437365563710',
          Year2: 'gid://shopify/ProductVariant/50461136355646',
          Month3: 'gid://shopify/ProductVariant/49202073993534',
        },
        [ShopifyStore.ZA]: {
          Year1: 'gid://shopify/ProductVariant/55281493967222',
          Year2: 'gid://shopify/ProductVariant/55281543381366',
          Month3: 'gid://shopify/ProductVariant/49202073993534',
        },
        [ShopifyStore.JP]: {
          Year1: 'gid://shopify/ProductVariant/55281493967222',
          Year2: 'gid://shopify/ProductVariant/55281543381366',
          Month3: 'gid://shopify/ProductVariant/49202073993534',
        },
      };
